// extracted by mini-css-extract-plugin
module.exports = {"container":"MediaError_container__1l-zz","iconContainer":"MediaError_iconContainer__1zFmG"};